import { User } from 'modules/users';
import {
  isAdmin,
  isEmployee,
  isOneOf,
  isReadEmployee,
  isSuperAdmin,
  isUser,
} from './utils';

const voters: Record<string, (user: User) => boolean> = {
  // Files
  'view files': isOneOf(isUser, isAdmin, isEmployee, isSuperAdmin),
  'create file': isOneOf(isAdmin, isEmployee, isSuperAdmin),
  'update file': isOneOf(isAdmin, isEmployee, isSuperAdmin),
  'delete file': isOneOf(isAdmin, isEmployee, isSuperAdmin),

  // Directories
  'create directory': isOneOf(isAdmin, isEmployee, isSuperAdmin),
  'update directory': isOneOf(isAdmin, isEmployee, isSuperAdmin),
  'delete directory': isOneOf(isAdmin, isEmployee, isSuperAdmin),

  // Assets
  'create asset': (user) => user.permissions['asset.create'],
  'create asset type': (user) => user.permissions['asset_type.create'],
  'create asset cluster': (user) => user.permissions['asset_cluster.create'],

  // Projects
  'create project': isOneOf(isAdmin, isEmployee, isSuperAdmin),

  // Directory / File Fields
  'update directory fields': isOneOf(isAdmin, isEmployee, isSuperAdmin),
  'update file fields': isOneOf(isAdmin, isEmployee, isSuperAdmin),

  // Directories / Files Custom Permissions
  'manage directory permissions': isOneOf(isEmployee, isSuperAdmin),

  // Components - Custom Data models
  'view components': isOneOf(isEmployee, isSuperAdmin),

  // Users
  'view users': isOneOf(isEmployee, isSuperAdmin),
  'create user': isOneOf(isEmployee, isSuperAdmin),
  'update user': isOneOf(isEmployee, isSuperAdmin),
  'delete user': isOneOf(isEmployee, isSuperAdmin),

  'manage user root directory': isOneOf(isSuperAdmin),
  'manage user directory access': isOneOf(isSuperAdmin),
  'manage user extra report filters': isOneOf(isEmployee, isSuperAdmin),
  'manage user sub account': isOneOf(isSuperAdmin),

  // Settings
  'view settings': isOneOf(isEmployee, isSuperAdmin),

  // Assets / Devices
  'view device groups': isOneOf(isAdmin, isEmployee, isSuperAdmin),
  'view service requests': isOneOf(isAdmin, isEmployee, isSuperAdmin),
  'view system log': isOneOf(isAdmin, isEmployee, isSuperAdmin),

  // Track & Trace
  'view track and trace': isOneOf(
    isReadEmployee,
    isAdmin,
    isEmployee,
    isSuperAdmin,
  ),
  'view track and trace trackable assets': isOneOf(isEmployee, isSuperAdmin),
} as const;

export default voters;
